export const CHECKOUT_BE_VALIDATION_GATE = 'Checkout:CheckoutInputValidationV2Gate';
export const CHECKOUT_DESCRIPTIVE_ERROR_MESSAGES_GATE = 'Checkout:DescriptiveErrorMessages';
export const CHECKOUT_BYOS_DIGITAL_WALLET_GATE = 'Checkout:BYOSDigitalWallet';
export const COMMERCE_INTERNATIONAL_CARD_FEE_FOR_US_GATE = 'Commerce:InternationalCardFeeForUS';
export const CPQ_PRODUCTS_TIERS_ALPHA_GATE = 'Cpq:Products:TiersAlpha';
export const CHECKOUT_CHECKBOX_GATE = 'Checkout:Checkbox';